let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5RQc9")).then(() => parcelRequire('5YjjN'));